// extracted by mini-css-extract-plugin
export const redemptionsModule = "RedemptionsModule__redemptionsModule__uTJDh";